// Import action types related to home primary data
import {
    GETEVENTS_FETCH_DATA_SUCCESS,
    GETEVENTS_HAVE_ERROR,
    GETEVENTS_ARE_LOADING,
  } from "../actionType";
  

  // Define the initial state for the HomePrimaryReducer
  const initialState = {
    data:     [],
    loading: true,
    error: null, // Initialize error as null for better error handling
  };
  
  // Reducer function to handle home primary-related actions and update state accordingly
  export function getEventReducer(state = initialState, action = null) {
    // console.log('getEventReducer called with action:', action);
    switch (action.type) {
      // Handle error case when fetching home primary data
      case GETEVENTS_HAVE_ERROR:
        // console.log('Handling error case');
        return {
          ...state,
          error: action.hasError, // Update the error state with the error from the action
          loading: false, // Set loading to false since the request is complete
        };
  
      // Handle loading state when home primary data is being fetched
      case GETEVENTS_ARE_LOADING:
        // console.log('Handling loading case');
        return {
          ...state,
          loading: action.isLoading, // Update the loading state with the loading status from the action
        };
  
      // Handle success case when home primary data is successfully fetched
      case GETEVENTS_FETCH_DATA_SUCCESS:
        // console.log('Handling success case with data:', action.event);
        return {
          ...state,
          data: action.event, // Update the data state with the fetched home primary data
          loading: false, // Set loading to false since the request is complete
          error: null, // Clear any previous errors
        };
  
      // Return the current state by default if action type is not recognized
      default:
        // console.log('Handling default case');
        return state;
    }
  }
  
